module.exports = __webpack_public_path__ + "img/feature_buy_en.2a1c30cf.png";